import AvisoDeSalida from './AvisoDeSalida';
import DialogoSalirSinGuardar from './DialogoSalirSinGuardar';

// EL AVISO Y LA PREGUNTA, PARA LAS PANTALLAS QUE SE PINTAN EN LUGAR DE LA
// APLICACIÓN · TC-DR-AT, auditoría H2 (4 oct 2026).
//
// «Pulsa atrás otra vez para salir de TEGO» y «¿Salir sin guardar?» se
// montan una vez en `App.jsx`. Pero el asistente del segundo factor y el
// de verificar la empresa se pintan desde el proveedor de sesión EN LUGAR
// de `App`: sin esto, atrás en ellos no tenía dónde enseñar el aviso ni la
// pregunta. Se pone al lado de esas pantallas, y solo de ésas: mientras
// `App` está montado, esto no lo está, así que nunca se ven dos.
export default function NavegacionDePuerta() {
  return (
    <>
      <AvisoDeSalida />
      <DialogoSalirSinGuardar />
    </>
  );
}
